import {Component, Inject, OnInit} from 'ng-metadata/core';
import {ChaptersAndReviewsService} from './chaptersAndReviews.service';
import {ALERT_MSG_TYPE, AlertFactory} from "../../infra/widgets/alerts/alertFactory.service";
import {IAlertMsg} from "../../infra/widgets/alerts/alertMsg.interface";
import {getSearchScopesMap, updateSearchScopesMap} from "../../appConfig/appConfigForward";
import {PrimoResponse} from "../../infra/dataStructures/PrimoResponses/doc.interfcae";
import {STATE_NAMES} from "../../primoExplore/primoExploreStates.module";
import {IState} from "angular-ui-router";
import {SearchFieldsService} from "../search.fields.service";
import {ChaptersAndReviewsItemService} from "./chaptersAndReviewsItem.service";
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";

const clone = require('lodash/clone');
const get = require('lodash/get');
const PREFIX_ALMA = "alma";
const PREFIX_TN = "TN_";

@Component({
    selector: 'prm-chapters-and-reviews',
    templateUrl: 'components/search/chaptersAndReviews/chapters-and-reviews.html',
})

export class PrmChaptersAndReviews implements OnInit{
    private SEARCH_STATE = STATE_NAMES.SEARCH;
    private savedSearchParams: Object;
    private _item: PrimoResponse.IDoc;

    set chaptersAlert(value) {
        this._chaptersAlert = value;
    }
    set reviewsAlert(value) {
        this._chaptersAlert = value;
    }

    private _chaptersAlert :IAlertMsg;
    private _reviewsAlert :IAlertMsg;

    constructor(private chaptersAndReviewsService: ChaptersAndReviewsService,
                private alertService:AlertFactory,
                @Inject('$state') private $state: IState,
                @Inject('$scope') private $scope: ng.IScope,
                private searchFieldsService: SearchFieldsService,
                private chaptersAndReviewsItemService: ChaptersAndReviewsItemService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$translate') private $translate: ng.translate.ITranslateService) {

        if (searchFieldsService.searchParams.query) {
            this.savedSearchParams = clone(searchFieldsService.searchParams);
            delete this.savedSearchParams.mfacet;
            delete this.savedSearchParams.offset ;
        }
        else {
            this.savedSearchParams = {
                vid: this.$state.params.vid,
                query: this.$state.params.query,
                search_scope: this.$state.params.search_scope,
                tab: this.$state.params.tab
            };

            const queryParts = this.savedSearchParams.query.split(",");
            const searchTerm = queryParts.length > 2 ? queryParts[2] : null;

            if (searchTerm) {
                const recordId = this.$state.params.docid || '';
                let cleanSearchTerm = null;

                if (this.configurationUtil.isSuprima()) { // Primo VE - handle only local search
                    if (searchTerm.startsWith(PREFIX_ALMA) && searchTerm === recordId){
                        cleanSearchTerm = searchTerm.replace(PREFIX_ALMA,"");
                    }

                } else { // Primo Classic - handle only CDI search
                    if (searchTerm.startsWith(PREFIX_TN) && searchTerm === recordId){
                        cleanSearchTerm = searchTerm.replace(PREFIX_TN,"");
                    }
                }

                if (cleanSearchTerm) {
                    this.savedSearchParams.query = this.$state.params.query.replace(searchTerm, cleanSearchTerm);
                }
            }
        }

        this.$scope.$on('addChaptersEvent', (event, data)=> {
            this.onAddRelatedItemsEvent(event, data)
        });

        this._chaptersAlert = alertService.create(ALERT_MSG_TYPE.GENERAL);
        this._chaptersAlert.show('<span translate="nui.results.relatedItems.chapter2chapter.note"></span>');

        this._reviewsAlert = alertService.create(ALERT_MSG_TYPE.GENERAL);
        this._reviewsAlert.show('<span translate="nui.results.relatedItems.book2review.note"></span>');

    }

    private onAddRelatedItemsEvent(event: ng.IAngularEvent, data) {
        this.updateItem();
        let params = data.params;
        this.chaptersAndReviewsService.performChaptersSearch(params).then(()=> {
            this.chaptersAndReviewsService.updateURLSearchParams(params);
        });
    }

    public updateItem(){
        this.item = this.chaptersAndReviewsService.item;
        if(this.chaptersAndReviewsItemService.relatedItemsObj) {
            return;
        }
        if(this.item) {
            this.getRelatedItems(this.item);
        } else {
            this.chaptersAndReviewsItemService.getItem().then((response: any) => {
                this.item = response.data;
                this.chaptersAndReviewsService.item = this.item;
                this.getRelatedItems(this.item);
            });
        }
    }

    ngOnInit() {
        this.updateItem();
    }

    get chaptersAlert(){
        return this._chaptersAlert;
    }

    get reviewsAlert(){
        return this._reviewsAlert;
    }

    private getRelatedItems (item) {
        this.chaptersAndReviewsService.getRelatedItems(item);
    }

    set item(item) {
        this._item = item;
    }

    // The specific item we came from
    get item() {
        return this._item;
    }

    public getRelatedItemsHeaderLabel () {
        if (!this.item) {
            return '';
        }
        if (this.type === 'reviews') {
            return this.$translate.instant('nui.results.relatedItems.book2review.title');
        }
        if (this.type === 'chapters') {
            let rsrctype = get(this.item, 'pnx.display.type[0]','b').toLowerCase();
            if (rsrctype === 'book'){
                return this.$translate.instant('nui.results.relatedItems.book2chapter.title');
            }
            if (rsrctype === 'book_chapter'){
                return this.$translate.instant('nui.results.relatedItems.chapter2chapter.title');
            }
        }
        
        return '';

    }

    get type() {
        return get(this.$state,'params.type');
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/chaptersAndReviews/chaptersAndReviews.directive.ts